<template>
  <div style="height: 100%;background-color: #fff;">
    <div class="amount">
      <span>{{amount}}</span>
      <div class="left_time">
        支付剩余时间:
        <yd-countdown :time="countdown" timetype="second"></yd-countdown>
      </div>
    </div>
    <yd-cell-group v-if="!Shenpi">
      <yd-cell-item>
        <span slot="left">订单详情</span>
        <span slot="right">{{order.ass_order_type}}</span>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">附加信息</span>
        <span slot="right">{{order.message?order.message:'空'}}</span>
      </yd-cell-item>
      <yd-cell-item @click.native="invoiceShow = true" v-if="system.is_open !== '0'">
        <span slot="left">发票：</span>
        <span slot="right">{{invoiceMsg}}<yd-icon name="more"></yd-icon></span>
      </yd-cell-item>
    </yd-cell-group>
    <div v-show="wxtipShow === false">
      <div v-for="(pay, key) in payTypes" :key="key" class="pay_way"
           @click="chooseone(pay.val)">
        <span><img src="" :onerror="payImage(pay.val)" alt="">&nbsp;&nbsp;&nbsp;{{pay.description}}</span>
        <input type="radio" :value="pay.val" v-model="payType"/>
      </div>
      <yd-button size="large" type="primary" v-show="!Shenpi" @click.native="pay">支付</yd-button>
      <yd-button size="large" v-show="Shenpi">等待审批</yd-button>
    </div>
    <img v-show="wxtipShow" src="~assets/image/webg.png"
         style="display: none;background-repeat: no-repeat;background-size: 100% 100%;width: 100%; height: 100%;position: fixed">

    <yd-popup v-model="invoiceShow" position="bottom" height="80%" style="color: black;">
      <yd-flexbox>
        <yd-flexbox-item>发票</yd-flexbox-item>
        <div>发票须知 <span @click="invoiceShow = false">X</span></div>
      </yd-flexbox>
      <!-- <br> -->
      <div v-if="system.is_open === '1'">
        <h3>开发票</h3>
        <yd-switch v-model="iskai"></yd-switch>
        <!--        <br> -->
      </div>
      <div v-show="iskai">
        <p class="invoice-info">{{system.info}}</p>
        <!--        <br> -->
        <h3>发票类型</h3>
        <yd-radio-group v-model="invoice.type">
          <yd-radio v-for="(i,key) in system.invoicetype" :val="key" :key="key">{{i}}</yd-radio>
        </yd-radio-group>

        <h3>发票抬头</h3>
        <yd-radio-group v-model="invoice.leixing">
          <yd-radio v-if="(system.InvoiceLeixing === '3' || system.InvoiceLeixing === '1')" val="1">个人</yd-radio>
          <yd-radio v-if="(system.InvoiceLeixing === '3' || system.InvoiceLeixing === '2')" val="2">单位</yd-radio>
        </yd-radio-group>
        <div class="invoice_inf">
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceNameRequire">*</i> 单位名称：</span>
            <input slot="right" type="text" v-model="invoice.name" class="input_height" placeholder="请输入单位名称">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceShuinoRequire">*</i> 纳税人识别码：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.shuino" placeholder="请输入纳税人识别码">
          </yd-cell-item>
          <yd-radio-group v-model="invoice.content">
            <h3>开票内容</h3>
            <yd-radio v-for="(i,key) in system.invoice_content" :key="key" :val="key">{{i}}</yd-radio>
          </yd-radio-group>
          <yd-radio-group v-show="(system.separate === '1')" v-model="invoice.way">
            <h3>分开开票</h3>
            <yd-radio val="1">开一张发票</yd-radio>
            <yd-radio val="2">分开开票</yd-radio>
          </yd-radio-group>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzaddressRequire">*</i> 单位地址：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzaddress" placeholder="请输入单位地址">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzphoneRequire">*</i> 电话号码：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzphone" placeholder="请输入电话号码">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzbankRequire">*</i> 开户银行：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzbank" placeholder="请输入开户银行">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzaccountRequire">*</i> 银行账户：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzaccount" placeholder="请输入银行账户">
          </yd-cell-item>
          <div v-if="system.invoicemail === '1'">
            <h3 slot="left">邮递</h3>
            <yd-switch v-model="invoice.needmail"></yd-switch>
          </div>
          <h3>收票人信息</h3>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceLxrRequire">*</i> 收票人姓名：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.lxr" placeholder="请输入收票人姓名">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceMobileRequire">*</i> 收票人手机：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.mobile" placeholder="请输入收票人手机">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceEmailRequire">*</i> 收票人邮箱：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.email" placeholder="请输入收票人邮箱">
          </yd-cell-item>
          <yd-cell-item arrow>
            <span slot="left"><i style="color: red" v-show="invoicePcdRequire">*</i> 所在地区：</span>
            <input slot="right" type="text" @click.stop="cityShow = true" class="input_height" v-model="pcd" readonly
                   placeholder="请选择省市县">
          </yd-cell-item>
          <yd-cityselect v-model="cityShow"
                         :callback="result1"
                         :provance="this.invoice.province"
                         :city="this.invoice.city"
                         :area="this.invoice.dist"
                         :items="district"
          ></yd-cityselect>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceAddressRequire">*</i> 详细地址：</span>
            <input slot="right" type="text" v-model="invoice.address" class="input_height" placeholder="请输入详细地址">
          </yd-cell-item>
          <yd-button size="large" type="primary" @click.native="saveInvoice">确定</yd-button>
        </div>
      </div>
    </yd-popup>

  </div>
</template>
<script type="text/babel">
import axios from 'axios'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import District from 'ydui-district/dist/gov_province_city_area_id'
import Vue from 'vue'
Vue.component(CitySelect.name, CitySelect)
var interval

export default {
  data () {
    return {
      params: this.$route.params,
      payTypes: [],
      payImageData: {
        '1': 'this.src="' + require('../../assets/image/weixin.png') + '"',
        '2': 'this.src="' + require('../../assets/image/zhifubao.png') + '"',
        '3': 'this.src="' + require('../../assets/image/yinhang.png') + '"',
        '4': 'this.src="' + require('../../assets/image/xianjin.png') + '"',
        '10': 'this.src="' + require('../../assets/image/yinhang.png') + '"'
      },
      payType: '',
      Shenpi: false,
      amount: '',
      payStatus: false,
      countdown: 0,
      downShow: false,
      wxtipShow: false,
      system: {},
      invoiceMsg: '不开发票',
      invoiceShow: false,
      invoiceNameRequire: true,
      invoiceShuinoRequire: true,
      invoiceZzaddressRequire: false,
      invoiceZzphoneRequire: false,
      invoiceZzbankRequire: false,
      invoiceZzaccountRequire: false,
      invoiceAddressRequire: false,
      invoicePcdRequire: false,
      invoiceEmailRequire: false,
      invoiceMobileRequire: false,
      invoiceLxrRequire: false,
      contactsShow: false,
      invoice: {
        type: '',
        content: '',
        way: 1,
        leixing: '',
        lxr: '',
        mobile: '',
        province: '',
        city: '',
        dist: '',
        address: '',
        name: '',
        shuino: '',
        zzaccount: '',
        zzbank: '',
        zzphone: '',
        zzaddress: '',
        email: '',
        needmail: 0
      },
      iskai: 0,
      cityShow: false,
      pcd: '',
      district: District,
      order: {}

    }
  },
  methods: {
    async checkOrder (check) {
      if (this.$route.path.indexOf('fair-pay') === -1) {
        clearInterval(interval)
        return false
      }
      let data = {id: this.params.order_id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token')
      await axios
        .post('/fair/order-cont', data)
        .then(res => {
          res = res.data
          if (res.status === 1) {
            this.amount = res.data.order.order_unpay
            this.order = res.data.order
            this.system = res.data.system
            if (this.system.is_open === '2') {
              this.iskai = 1
            }
            if (this.system.invoicemail === '2') {
              this.invoice.needmail = true
            }
            if (res.data.order.countdown !== undefined) {
              this.downShow = true
              this.countdown = res.data.order.countdown
            }
            if (res.data.order.status < '1') {
              // 订单已失效！
              return false
            } else if (res.data.order.status === '10') {
              this.$dialog.toast({
                mes: '订单已支付'
              })
              this.$router.push({path: '/' + this.params.id + '/single-my'})
              this.payStatus = false
            }
            if (res.data.order.isneedshenpi === 1 && res.data.order.product_type !== '29') {
              // 等待审批
              this.$dialog.toast({
                mes: '等待审批'
              })
              this.Shenpi = true
              return false
            }
            if (check) {
              axios
                .post('/user/zhifu-setting', {orderid: this.params.order_id, fairid: this.params.id})
                .then(payTypes => {
                  payTypes = payTypes.data
                  if (payTypes.status === 1) {
                    payTypes.res.forEach(payType => {
                      if (payType.cloum_value === '1') {
                        this.payTypes.push(payType)
                      }
                    })
                    this.payStatus = true
                    interval = setInterval(this.checkOrder, 5000)
                  }
                })
            }
          }
        })
        .catch(function (res) {
          console.log(res)
        })
    },
    pay () {
      let invoiceRes = this.checkInvoice()
      if (!invoiceRes) {
        this.$dialog.toast({
          mes: '请检查发票信息是否正确'
        })
        return false
      }
      this.checkOrder()
      if (this.payStatus === false) {
        return false
      }
      let data = {
        ExhInvoice: this.invoice,
        ExhBusinessOrder: {
          payway: this.payway
        },
        iskai: this.iskai
      }
      axios
        .post(this.$store.state.api_url + 'ass/order/do-buy?uid=' + this.$store.state.uid + '&id=' + this.params.order_id, data)
        .then(res => {
          res = res.data
          if (res.status === 1) {
            if (this.payType === 1) {
              if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
                window.location.href = this.$store.state.api_url + 'site/get-openid?orderid=' + this.params.order_id
              } else {
                axios
                  .get('/wechat-js/index?orderid=' + this.params.order_id)
                  .then(res => {
                    res = res.data
                    if (res.status === 1) {
                      // window.location.href = 'wepay.html?wxurl=' + res.data
                      this.$router.push({path: '/' + this.params.id + '/weixin-pay?url=' + res.data})
                      return false
                    } else {
                      this.$dialog.toast({
                        mes: res.msg
                      })
                    }
                  })
              }
            } else if (this.payType === 2) {
              if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
                this.wxtipShow = true
              } else {
                var url = this.$store.state.api_url + 'alipay-m2/index'
                window.location.href = url + '?orderid=' + this.params.order_id
              }
            } else if (this.payType === 3) {
              this.$router.push({path: '/' + this.params.id + '/bank-transfer/' + this.params.order_id})
            } else if (this.payType === 4) {
              axios
                .post('/fair/remit', {orderid: this.params.order_id, payment: this.payType})
                .then(res => {
                  res = res.data
                  if (res.status === 1) {
                    this.$router.push({path: '/' + this.params.id + '/single-my'})
                  }
                })
            }
          }
        })
    },
    payImage (pay) {
      let img = ''
      if (this.payImageData[pay]) {
        img = this.payImageData[pay]
      }
      return img
    },
    chooseone (val) {
      this.payType = val
    },
    HistoryBack () {
      window.history.back()
    },
    saveInvoice () {
      var type = ''
      if (this.invoice.type === '1') {
        type = '普票'
      }
      if (this.invoice.type === '2') {
        type = '电子发票'
      }
      if (this.invoice.type === '3') {
        type = '增值发票'
      }
      if (this.iskai) {
        this.invoiceMsg = type + '(' + this.invoice.name + ')'
      } else {
        this.invoiceMsg = '不开发票'
      }
      let invoiceRes = this.checkInvoice()
      if (invoiceRes) {
        this.invoiceShow = false
      }
    },
    checkInvoiceRequire () {
      this.invoiceEmailRequire = false
      if (this.invoice.type === '1') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
      } else if (this.invoice.type === '2') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
        this.invoiceEmailRequire = true
      } else if (this.invoice.type === '3') {
        this.invoiceNameRequire = true
        this.invoiceShuinoRequire = true
        this.invoiceZzaddressRequire = true
        this.invoiceZzphoneRequire = true
        this.invoiceZzbankRequire = true
        this.invoiceZzaccountRequire = true
      }
      if (this.invoice.leixing === '1' && this.invoice.type !== '3') {
        this.invoiceShuinoRequire = false
      } else {
        this.invoiceShuinoRequire = true
      }
      if (this.invoice.needmail === true) {
        this.invoiceLxrRequire = true
        this.invoicePcdRequire = true
        this.invoiceMobileRequire = true
        this.invoiceAddressRequire = true
      } else {
        this.invoiceLxrRequire = false
        this.invoicePcdRequire = false
        this.invoiceMobileRequire = false
        this.invoiceAddressRequire = false
      }
    },
    checkInvoice () {
      if (this.iskai) {
        if (this.invoice.type === '') {
          this.$dialog.toast({
            mes: '发票类型必填'
          })
          return false
        }
        if (this.invoice.leixing === '') {
          this.$dialog.toast({
            mes: '发票抬头类别必填'
          })
          return false
        }
        if (this.invoiceNameRequire) {
          if (this.invoice.name === '' || this.invoice.name.length <= 0) {
            this.$dialog.toast({
              mes: '发票名称必填'
            })
            return false
          }
        }
        if (this.invoiceShuinoRequire) {
          if (this.invoice.shuino === '' || this.invoice.shuino.length <= 0) {
            this.$dialog.toast({
              mes: '发票税号必填'
            })
            return false
          }
        }
        if (this.invoiceZzaddressRequire) {
          if (this.invoice.zzaddress === '' || this.invoice.zzaddress.length <= 0) {
            this.$dialog.toast({
              mes: '单位地址必填'
            })
            return false
          }
        }
        if (this.invoiceZzphoneRequire) {
          if (this.invoice.zzphone === '' || this.invoice.zzphone.length <= 0) {
            this.$dialog.toast({
              mes: '电话号码必填'
            })
            return false
          }
        }
        if (this.invoiceZzbankRequire) {
          if (this.invoice.zzbank === '' || this.invoice.zzbank.length <= 0) {
            this.$dialog.toast({
              mes: '开户银行必填'
            })
            return false
          }
        }
        if (this.invoiceZzaccountRequire) {
          if (this.invoice.zzaccount === '' || this.invoice.zzaccount.length <= 0) {
            this.$dialog.toast({
              mes: '银行账户必填'
            })
            return false
          }
        }
        if (this.invoiceLxrRequire) {
          if (this.invoice.lxr === '' || this.invoice.lxr.length <= 0) {
            this.$dialog.toast({
              mes: '收件人姓名必填'
            })
            return false
          }
        }
        if (this.invoiceMobileRequire) {
          if (this.invoice.mobile === '' || this.invoice.mobile.length <= 0) {
            this.$dialog.toast({
              mes: '收件人手机号必填'
            })
            return false
          }
        }
        if (this.invoiceEmailRequire) {
          if (this.invoice.email === '' || this.invoice.email.length <= 0) {
            this.$dialog.toast({
              mes: '收件人邮箱必填'
            })
            return false
          }
        }
        if (this.invoicePcdRequire) {
          if (this.invoice.province === '' || this.invoice.province.length <= 0 || this.invoice.city === '' || this.invoice.city.length <= 0 || this.invoice.dist === '' || this.invoice.dist.length <= 0) {
            this.$dialog.toast({
              mes: '收件人省市县必填'
            })
            return false
          }
        }
        if (this.invoiceAddressRequire) {
          if (this.invoice.address === '' || this.invoice.address.length <= 0) {
            this.$dialog.toast({
              mes: '收件人详细地址必填'
            })
            return false
          }
        }
      }
      return true
    },
    result1 (ret) {
      this.pcd = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
      this.invoice.province = ret.itemValue1
      this.invoice.city = ret.itemValue2
      this.invoice.dist = ret.itemValue3
    }
  },
  mounted () {
    this.checkOrder(1)
  },
  watch: {
    'invoice.type': function () {
      this.checkInvoiceRequire()
    },
    'invoice.leixing': function () {
      this.checkInvoiceRequire()
    },
    'invoice.needmail': function () {
      this.checkInvoiceRequire()
    },
    'iskai': function () {
      this.invoice.leixing = 1
      if (this.system.InvoiceLeixing === '2') {
        this.invoice.leixing = 2
      }
      for (let key in this.system.invoicetype) {
        this.invoice.type = key
        break
      }
      for (let key in this.system.invoice_content) {
        this.invoice.content = key
        break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .amount
    text-align: center
    padding: .4rem 0

  .amount span
    color: #f00
    font-size: .6rem

  .left_time
    color: #333
    font-size: .24rem

  .left_time span
    color: #333
    font-size: .24rem

  .yd-cell-item
    padding: 0 .4rem

  .yd-cell-item:not(:last-child)::after
    opacity: 0.4
    width: calc(100% - .8rem)
    margin-left: .4rem

  .pay_way
    padding: 0 .4rem
  .pay_way > :first-child
    line-height: .8rem !important
  .pay_way>:nth-child(2)>:nth-child(2)::after
    display: none!important

  .pay_way img
    width: .4rem
  .pay_way input
    float: right
    height: .8rem
  .invoice-info
    color: red
    margin: .2rem 0
</style>



// WEBPACK FOOTER //
// src/views/template1/FairPay2.vue